interface ContainerProps {
  children: React.ReactNode;
}

export function Container({children}: ContainerProps) {
  return <div className="tw-w-full tw-max-w-screen-xl tw-mx-auto tw-pt-4 tw-pb-20 tw-px-6 xl:tw-px-0">{children}</div>;
}
